var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSends = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8401 8.51953H20.1601C12.9193 8.51953 9.29892 8.51953 7.0495 10.769C5.42991 12.3885 4.97643 14.7189 4.84946 18.5995H43.1507C43.0237 14.7189 42.5703 12.3885 40.9507 10.769C38.7012 8.51953 35.0809 8.51953 27.8401 8.51953ZM20.16 39.2389H27.84C35.0808 39.2389 38.7012 39.2389 40.9506 36.9895C43.2 34.7401 43.2 31.1197 43.2 23.8789C43.2 23.0304 43.2 22.2316 43.1964 21.4789H4.80367C4.80005 22.2316 4.80005 23.0304 4.80005 23.8789C4.80005 25.1451 4.80005 26.3006 4.81208 27.3575L7.50535 24.6642C9.19241 22.9771 11.9277 22.9771 13.6147 24.6642L17.4547 28.5042C19.1418 30.1913 19.1418 32.9265 17.4547 34.6136C16.7335 35.3349 15.8207 35.7478 14.88 35.8523V39.1895C16.3891 39.2389 18.1327 39.2389 20.16 39.2389ZM27.84 30.1189H35.52C36.3153 30.1189 36.96 30.7636 36.96 31.5589C36.96 32.3542 36.3153 32.9989 35.52 32.9989H27.84C27.0448 32.9989 26.4 32.3542 26.4 31.5589C26.4 30.7636 27.0448 30.1189 27.84 30.1189ZM24.48 31.5589C24.48 30.7636 23.8353 30.1189 23.04 30.1189H20.16C19.3648 30.1189 18.72 30.7636 18.72 31.5589C18.72 32.3542 19.3648 32.9989 20.16 32.9989H23.04C23.8353 32.9989 24.48 32.3542 24.48 31.5589ZM9.54181 26.7007C10.1042 26.1383 11.0159 26.1383 11.5783 26.7007L15.4183 30.5407C15.9806 31.103 15.9806 32.0148 15.4183 32.5771C14.8559 33.1395 13.9442 33.1395 13.3818 32.5771L12 31.1954V39.2389C12 40.0342 11.3553 40.6789 10.56 40.6789C9.76476 40.6789 9.12005 40.0342 9.12005 39.2389V31.1954L7.73828 32.5771C7.17593 33.1395 6.26417 33.1395 5.70181 32.5771C5.13946 32.0148 5.13946 31.103 5.70181 30.5407L9.54181 26.7007Z",
    fill: "url(#paint0_linear_7910_15808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7910_15808",
    x1: 4.80005,
    y1: 8.51953,
    x2: 36.4602,
    y2: 46.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FFA99E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF4138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70808"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSends, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sends.8b8a97e9.svg";
export { ForwardRef as ReactComponent };